import { TDocument } from '@modules/documents';
import { TFile } from '@modules/files';
import isTFile from '@modules/files/helpers/isTFile.helper';
import { TItemVersion } from '../types/items.types';

const findItemVersion = (item: TDocument | TFile, versionId: string | undefined) => {
  if (isTFile(item)) {
    const version = item.versions.find((v) => v.id === versionId);
    return version && ({ type: item.type, item, version } satisfies TItemVersion);
  }
  const version = item.versions.find((v) => v.id === versionId);
  return version && ({ type: item.type, item, version } satisfies TItemVersion);
};

export default findItemVersion;
